import React from "react";

const VehicleInputTitle = ({title, extraClassName}) => (
    <div className={`formLabelAndTooltipWrapper ${extraClassName ? extraClassName : ''}`}>
        <h4>{title}</h4>
    </div>
);

export default VehicleInputTitle;
